export const footprintOptions = [
  {
    title: 'On-net buildings',
    value: 'lit',
    status: 'LIT'
  },
  {
    title: 'Footprint buildings',
    value: 'footprint',
    status: 'Footprint'
  },
  {
    title: 'Construction commenced',
    value: 'build',
    status: 'BuildCommenced'
  },
  {
    title: 'Coming Soon Buildings',
    value: 'soon',
    status: 'ComingSoon'
  },
  {
    title: 'Not available buildings',
    value: 'other',
    status: 'Other'
  }
]
